import { render } from "./AddCategory.vue?vue&type=template&id=4a694656&scoped=true&ts=true"
import script from "./AddCategory.vue?vue&type=script&lang=ts"
export * from "./AddCategory.vue?vue&type=script&lang=ts"

import "./AddCategory.vue?vue&type=style&index=0&id=4a694656&lang=scss&scoped=true"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a694656"]])

export default __exports__